import Datepicker from 'components/Datepicker/Datepicker';

export default Datepicker;
